import { BadgeCheck, FileText, Ruler, Truck } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

const ITEMS = [
  { icon: BadgeCheck, title: "Sole Proprietorship", note: "Direct proprietor communication" },
  { icon: Ruler, title: "Grade-wise supply", note: "Indicative size categories, sample approved" },
  { icon: FileText, title: "GST invoice", note: `GSTIN ${BUSINESS.gstin}` },
  { icon: Truck, title: "Hyderabad dispatch", note: "Telangana and feasible outstation supply" },
];

export const TrustBar = () => (
  <section className="bg-spice-sand border-y border-spice-line px-4 sm:px-6 py-6" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-4">
      {ITEMS.map((item) => (
        <div key={item.title} className="flex items-start gap-3" data-testid={`trust-item-${item.title.toLowerCase().replace(/\s+/g, "-")}`}>
          <item.icon className="w-5 h-5 text-spice-green shrink-0 mt-0.5" aria-hidden="true" />
          <div className="min-w-0">
            <div className="text-xs sm:text-sm font-semibold text-spice-ink">{item.title}</div>
            <div className="text-[11px] text-spice-muted leading-snug">{item.note}</div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
